export enum QualityProcedureInputType {
  None,
  Select,
  InputBox,
}
